'use client';

import React from 'react';
import IconClose from '@/components/svgs/icons/close-icon';

const COMMITMENTS = [
  {
    title: 'Sell or share your profile',
    text: "Your details go to a company when you apply to that company. Not before, and not to anyone else. We don't sell candidate data to third parties.",
  },
  {
    title: 'Pad the board with dead roles',
    text: "Listings expire when the feed drops them or the posting lapses. A count that never goes down isn't a count.",
  },
  {
    title: 'Make unsubscribing hard',
    text: "One click to pause, one to stop, both in every email. Pausing doesn't delete your ranking — it'll be there when you come back.",
  },
  {
    title: "Re-send what you've passed on",
    text: 'Dismiss a role and it stays dismissed. Dismiss enough of one kind and we adjust what clears the bar.',
  },
];

const AboutCommitmentsDC = () => {
  return (
    <div className="w-full py-20 border-t border-b border-dc-gallery">
      <div className="px-4 container mx-auto">
        <p className="text-dc-rock-spray font-bold text-sm">COMMITMENTS</p>
        <h2 className="mt-5 text-dc-cod-gray font-bold max-md:text-3xl md:text-[40px] md:leading-11">
          What we don&apos;t do
        </h2>
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 auto-rows-fr">
          {COMMITMENTS.map((el) => {
            return (
              <div
                key={el.title}
                className="flex h-full justify-center gap-5 border border-dc-gallery rounded-xl p-4 bg-white"
              >
                <IconClose
                  aria-hidden="true"
                  className="w-3 h-3 mt-1.5 fill-current shrink-0 stroke-dc-vermilion!"
                />
                <div>
                  <p className="text-dc-cod-gray font-bold">{el.title}</p>
                  <p className="text-dc-dove-gray text-sm mt-2">{el.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AboutCommitmentsDC;
